<template>
  <div>
    <div v-if="loading" class="dot-opacity-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div v-if="downtimeData && downtimeData.length" class="pr-1 ml-n4">
      <apexchart
        type="rangeBar"
        width="100%"
        height="150"
        :options="chartOptions"
        :series="dataReady"
      ></apexchart>
    </div>
    <div v-else class="row justify-content-center">
      <h4 class="p-3">{{ $t('dashboards.noData') }}</h4>
    </div>
  </div>
</template>

<script>
import workCenterEvents from '@/api/boxinfo/workCenterEvents.gql';
import moment from 'moment';
import ru from 'apexcharts/dist/locales/ru.json';

export default {
  name: 'DowntimeChart',
  components: {
    apexchart: () => import('vue-apexcharts'),
  },
  props: {
    workCenterId: String,
    period: Object,
    stateId: String,
  },
  apollo: {
    downtimeData: {
      query: workCenterEvents,
      variables() {
        return {
          workCenterId: this.workCenterId,
          period: this.period,
        };
      },
      pollInterval: 300000,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.workCenterEventsList && queryData.workCenterEventsList.length) {
          return queryData.workCenterEventsList;
        } else {
          //this.$store.commit('SET_ERROR', this.$t('box.error.downtime'))
          return [];
        }
      },
      skip() {
        return !this.workCenterId;
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },

      fetchPolicy: 'network-only',
    },
  },
  data() {
    return {
      downtimeData: [],
      selectionInner: null,
      selectionChangeCounter: 0,
    };
  },
  computed: {
    isiOS() {
      return !!navigator.platform && /Mac|iPad|iPhone|iPod/.test(navigator.platform);
    },
    chartOptions() {
      const vm = this;
      const isIOS = this.isiOS;
      return {
        chart: {
          id: 'workCenterEvents',
          group: 'efficiency',
          type: 'rangeBar',
          animations: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          locales: [ru],
          defaultLocale: 'ru',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '100%',
            barHeight: '100%',
          },
        },
        yaxis: {
          show: true,
          labels: {
            show: false,
            minWidth: 30,
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false,
            style: {
              colors: 'grey',
            },
          },
        },
        tooltip: {
          theme: 'dark',
          x: {
            formatter: function (value) {
              return isIOS
                ? moment(value).add(3, 'h').format('DD.MM.YYYY HH:mm:ss')
                : moment(value).format('DD.MM.YYYY HH:mm:ss');
            },
          },
          y: {
            formatter: function (value, { seriesIndex, dataPointIndex }) {
              const series =
                vm.dataReady && vm.dataReady.length > seriesIndex ? vm.dataReady[seriesIndex] : 0;
              const point =
                series && series.data.length > dataPointIndex ? series.data[dataPointIndex] : 0;
              const name = point ? point.name : '';

              return `${name}<br>`;
            },
          },
        },
        grid: {
          show: false,
        },
      };
    },
    minDate() {
      return this.period.dateStart
        ? new Date(this.period.dateStart).getTime()
        : new Date().getTime();
    },
    maxDate() {
      return this.period.dateEnd ? new Date(this.period.dateEnd).getTime() : new Date().getTime();
    },
    dataReady() {
      var data = this.prepData(this.downtimeData);
      return [
        {
          data,
        },
      ];
    },
    loading() {
      return this.$apollo.queries.downtimeData.loading;
    },
  },
  methods: {
    dateToTimestamp(date, isiOS) {
      return isiOS ? moment(date).add(-3, 'h').valueOf() : moment(date).valueOf();
    },
    prepData(values) {
      const isIOS = this.isiOS;

      let data = {};
      const darkColor = '#3b3c3d';
      data = values.map((i) => {
        return {
          name: i.state.name,
          fillColor: i.state.color
            ? this.stateId
              ? this.stateId === i.state.id
                ? i.state.color.trim()
                : darkColor
              : i.state.color.trim()
            : '#6D6E71',
          x: 'code',
          y: [this.dateToTimestamp(i.eventStart, isIOS), this.dateToTimestamp(i.eventEnd, isIOS)],
        };
      });
      return data;
    },
  },
};
</script>
